<template>
  <div class="draw-details-wrapper">
    <Tabs :tabs="enabledTabs" :active-tab="activeComponent" @change="updateTab" />
    <div class="draw-details-body">
      <component :is="activeComponent.component" />
    </div>
  </div>
</template>

<script>
import { each, filter, findIndex } from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import Tabs from '@nsftx/games-sdk-js/src/components/Tabs';
import { eventBus } from '@nsftx/games-sdk-js';
import Boost from './Boost';
import Statistics from './Statistics';
import Results from './Results';
import GameHelp from './GameHelp';

export default {
  name: 'DrawDetails',
  components: {
    Boost,
    Statistics,
    Results,
    Tabs,
    GameHelp,
  },
  data() {
    return {
      tabs: [],
      activeComponent: {},
      enabledTabs: [],
    };
  },
  computed: {
    ...mapState(['config']),
    ...mapGetters(['translations', 'isBoostActive', 'isMobile', 'isDesktop']),
    ...mapGetters('user', ['user']),
  },
  watch: {
    'user.profile.id': function reinitializeActiveComponent() {
      this.activeComponent = {};
      setTimeout(() => {
        [this.activeComponent] = this.enabledTabs;
      }, 100);
    },
  },
  mounted() {
    eventBus.$on('ShowResults', this.handleShowResults);
    eventBus.$on('ShowStats', this.handleShowStats);
    eventBus.$on('ShowHelp', this.handleShowHelp);
    this.tabs = [
      {
        label: this.translations.general_activity,
        component: 'Boost',
        disabled: !this.isBoostActive || !this.isDesktop,
      },
      {
        label: this.translations.general_statistics,
        component: 'Statistics',
        disabled: false,
      },
      {
        label: this.translations.general_results,
        component: 'Results',
        disabled: false,
      },
      {
        label: this.translations.general_help,
        component: 'GameHelp',
        disabled: !this.config.ui.config.luckySixHelpPath || this.isDesktop,
      },
    ];

    this.enabledTabs = filter(this.tabs, (tab) => !tab.disabled);

    each(this.enabledTabs, (t, i) => {
      const tab = t;
      tab.id = i;
    });

    [this.activeComponent] = this.enabledTabs;
    this.getStats();
    this.getResults();
  },
  beforeDestroy() {
    eventBus.$off('ShowResults', this.handleShowResults);
    eventBus.$off('ShowStats', this.handleShowStats);
    eventBus.$off('ShowHelp', this.handleShowHelp);
  },
  methods: {
    ...mapActions(['getResults', 'getStats']),
    updateTab(event) {
      const activeIndex = findIndex(this.enabledTabs, (tab) => event.id === tab.id);
      this.activeComponent = this.enabledTabs[activeIndex];
    },
    handleShowResults() {
      [, this.activeComponent] = this.enabledTabs;
    },
    handleShowStats() {
      [this.activeComponent] = this.enabledTabs;
    },
    handleShowHelp() {
      if (this.isMobile) {
        [, , this.activeComponent] = this.enabledTabs;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.draw-details-wrapper {
  width: 100%;
  height: 100%;
  background-color: var(--card);

  .tabs {
    --tab-border-color: rgba(255, 255, 255, 0.05);
    border-bottom: 2px solid var(--tab-border-color);
    background-color: var(--card);
  }

  .draw-details-body {
    float: left;
    width: 100%;
    background-color: var(--card);
    text-align: center;
    min-height: 600px;
    height: calc(100% - 40px);
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }

    ::v-deep {
      .helpWrapper {
        iframe {
          height: 100vh;
        }
      }
    }
  }
}
</style>
